import depthsSource from "./void-cave-depths-source.json";

const TILE_SIZE = Number(depthsSource.tilewidth || 32);
const FALLBACK_ENTRANCE = Object.freeze({
  x: 608,
  y: 1600,
  width: 192,
  height: 64,
});

const navigationObjects =
  depthsSource.layers.find(
    (layer) => layer.type === "objectgroup" && layer.name === "Navigation",
  )?.objects || [];

const normalizeRect = (object, fallback = null) => {
  if (!object) return fallback;
  return Object.freeze({
    x: Number(object.x || 0),
    y: Number(object.y || 0),
    width: Number(object.width || 0),
    height: Number(object.height || 0),
  });
};

export const VOID_CAVE_DEPTHS_ENTRANCE_RECT = normalizeRect(
  navigationObjects.find((object) => object.name === "entrance"),
  FALLBACK_ENTRANCE,
);

export const VOID_CAVE_DEPTHS_EXIT_RECTS = Object.freeze(
  navigationObjects
    .filter((object) => object.type === "exit")
    .reduce(
      (rects, object) => ({
        ...rects,
        [object.name]: normalizeRect(object),
      }),
      {},
    ),
);

export const VOID_CAVE_DEPTHS_ENTRY_SPAWN = Object.freeze({
  x:
    VOID_CAVE_DEPTHS_ENTRANCE_RECT.x +
    VOID_CAVE_DEPTHS_ENTRANCE_RECT.width / 2,
  y: VOID_CAVE_DEPTHS_ENTRANCE_RECT.y - TILE_SIZE * 1.5,
});

const rectanglesOverlap = (left, right) =>
  left.x < right.x + right.width &&
  left.x + left.width > right.x &&
  left.y < right.y + right.height &&
  left.y + left.height > right.y;

export const isVoidCaveDepthsNavigationTileWalkable = (tileX, tileY) => {
  const tileRect = {
    x: Number(tileX) * TILE_SIZE,
    y: Number(tileY) * TILE_SIZE,
    width: TILE_SIZE,
    height: TILE_SIZE,
  };

  return [
    VOID_CAVE_DEPTHS_ENTRANCE_RECT,
    ...Object.values(VOID_CAVE_DEPTHS_EXIT_RECTS),
  ].some((rect) => rectanglesOverlap(tileRect, rect));
};
